'use client'

import { Toaster } from 'sonner'
import { useTheme } from 'next-themes'

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme()
  
  return (
    <>
      {children}
      <Toaster richColors position="bottom-center" theme={theme as 'light' | 'dark'} />
    </>
  )
}